import { usePagination, DOTS } from '../../services/usePagination';
import { StyledPaginationContainer } from './pagination.style';

import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md'

const Pagination = props => {
    const {
        onPageChange,
        totalCount,
        siblingCount = 0,
        currentPage,
        pageSize,
    } = props;

    const paginationRange = usePagination({
        currentPage,
        totalCount,
        siblingCount,
        pageSize
    });

    if (currentPage === 0 || paginationRange.length < 2) {
        return null;
    }

    const onNext = () => {
        onPageChange(currentPage + 1);
    };

    const onPrevious = () => {
        onPageChange(currentPage - 1);
    };

    let lastPage = paginationRange[paginationRange.length - 1];
    return (
        <StyledPaginationContainer
            className='pagination-container'
        >
            <span
                className={currentPage === 1 ? 'pagination-item disabled' : 'pagination-item'}
                onClick={onPrevious}
            >
                <div className="arrow-container">
                    <MdKeyboardArrowLeft size={20} />
                </div>
            </span>
            {paginationRange.map(pageNumber => {
                if (pageNumber === DOTS) {
                    return <span className="pagination-item dots">&#8230;</span>;
                }

                return (
                    <span
                        className={pageNumber === currentPage ? 'pagination-item selected' : 'pagination-item'}
                        onClick={() => onPageChange(pageNumber)}
                    >
                        {pageNumber}
                    </span>
                );
            })}
            <span
                className={currentPage === lastPage ? 'pagination-item disabled' : 'pagination-item'}
                onClick={onNext}
            >
                <div className="arrow-container">
                    <MdKeyboardArrowRight size={20} />
                </div>
            </span>
        </StyledPaginationContainer>
    );
};

export { Pagination };